import React, { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import companyPerformanceType from "./types/companyPerformanceType";
import InterviewRateGraph from "./InterviewRateGraph";
import {
  Wrapper,
  Title,
  TitleText,
  TitleTooltip,
  MemberSince,
  Body,
  MultiRow,
  Row,
  Column,
  ColumnTitle,
  ColumnValue,
  PlaceholderText,
} from "./styles/company-performance-styles";

export const CompanyPerformance = ({
  companyPerformance,
  togglePerformanceInfoModal,
  isEmployer,
  isAgencyNew,
}) => (
  <Wrapper
    className="animated delay-3 fadeIn"
    noData={!companyPerformance.testimonial}
  >
    <Title>
      <Fragment>
        <ReactTooltip
          html
          place="bottom"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="company-performance-tooltip"
        />
        <TitleText>
          company performance
          {!isEmployer && (
            <TitleTooltip
              onClick={() => togglePerformanceInfoModal()}
              data-tip="Click to learn more"
              data-for="company-performance-tooltip"
            >
              <FontAwesomeIcon icon={faInfoCircle} />
            </TitleTooltip>
          )}
        </TitleText>
        <MemberSince data-test-id="company-member-since">
          Member since {companyPerformance.memberSince}
        </MemberSince>
      </Fragment>
    </Title>
    {isEmployer && isAgencyNew ? (
      <PlaceholderText data-test-id="new-user-placeholder">
        We&apos;re working on our performance metrics right now.
      </PlaceholderText>
    ) : (
      <Body>
        <Fragment>
          <MultiRow>
            <Row>
              <Column flexSize={1}>
                <ColumnValue data-test-id="company-interview-rate" small>
                  {companyPerformance.interviewRate}%
                </ColumnValue>
                <ColumnTitle small>Interview Rate</ColumnTitle>
              </Column>
              <Column flexSize={2}>
                <InterviewRateGraph
                  interviewRate={companyPerformance.interviewRate}
                  isEmployer={isEmployer}
                />
              </Column>
            </Row>
            <Row>
              <Column flexSize={1}>
                <ColumnValue data-test-id="company-engagement-count" small>
                  {companyPerformance.engagements}
                </ColumnValue>
                <ColumnTitle small>Engagements</ColumnTitle>
              </Column>
              <Column flexSize={1}>
                <ColumnValue data-test-id="company-interview-count" small>
                  {companyPerformance.interviewCount}
                </ColumnValue>
                <ColumnTitle small>Interviews</ColumnTitle>
              </Column>
              <Column flexSize={1}>
                <ColumnValue data-test-id="company-placement-count" small>
                  {companyPerformance.placements}
                </ColumnValue>
                <ColumnTitle small>Placements</ColumnTitle>
              </Column>
            </Row>
          </MultiRow>
        </Fragment>
      </Body>
    )}
  </Wrapper>
);

CompanyPerformance.propTypes = {
  companyPerformance: companyPerformanceType.isRequired,
  togglePerformanceInfoModal: PropTypes.func.isRequired,
  isEmployer: PropTypes.bool.isRequired,
  isAgencyNew: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  companyPerformance: state.agencyProfile.profileData.companyPerformance,
  isEmployer: state.agencyProfile.profileData.currentUser.isEmployer,
  isAgencyNew: state.agencyProfile.profileData.user.new,
});

export default connect(mapStateToProps, {})(CompanyPerformance);
